import { render } from "./login.vue?vue&type=template&id=a59195d4&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=a59195d4&scoped=true&lang=css"

import exportComponent from "D:\\code\\zt\\Buyer\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a59195d4"]])

export default __exports__